import React from "react";
import "./TutorSignUpPage.scss";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import logo from "../../Assets/Icon/logo.png";
import logo_mobile from "../../Assets/Icon/logo_mobile.png";
import arrow from "../../Assets/Common/left-arrow.svg";
import { ReactSVG } from "react-svg";
import user from "../../Assets/Common/user.svg";
import email_ico from "../../Assets/Common/email.svg";
import key from "../../Assets/Common/key.svg";
import { 
  SelectBox,
  SelectBox2,
  CheckBox,
  StartButton, 
  InputBox, 
  TrainingVideo,
  Availability,
  CheckSection
} from "../../Components";
import place from "../../Assets/Common/place.svg";
import {
  tutorSignUp,
  tutorProfileUpdate,
  getSchools,
  getCities,
  getLevels,
  getSubjects
} from "../../Redux/Actions";
import { GetDashboardUrl } from "../../Constant";
import { Hours, WeekData, DegreeType, Months, Days,  } from './SignupData';

import Helper from '../../Utils/Helper';
import _ from 'lodash'

class TutorSignUpPage extends React.Component {
  state = {
    currentProgress: 1,

    schools: [],
    levels_subjects: [],

    photo: "",
    upload_picture: "",
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    address: "",
    city: "",
    region_id: "",
    zipcode: "",
    phone: "",
    deliver: "",
    referal_code: "",
   
    country: 'US',

    school1_id: 0,
    school1_name: "",
    major: "",
    major_gpa: "",

    school2_id: 0,
    school2_name: "",
    degree2: "",
    degree2_type: "",

    school3_id: 0,
    school3_name: "",
    degree3: "",
    degree3_type: "",

    profile_title: "",
    fan_facts: "",
    about_me: "",
    experience: "",
    approach: "",
    showPopUp: false,

    schedule_confirm: false,
    parms_validation: null,
    training_status: 0,
    schedule_data: [],

    classifications: '',
    schedule: '',
    policy_checked: false,

    authorize_work: false,

    practice: false,

    YEARS: [],
    month: 'January',
    selected_month: '01',
    day: '01',
    year: new Date().getFullYear() - 20,
  };

  constructor(props) {
    super(props);
    this.workContainer = React.createRef();
  }

  componentDidMount=()=> {
    let currentYear = new Date().getFullYear();
    let temp = [];
    for (let i = 0; i <= 80; i++) {
        temp.push({id: i, name: currentYear - i});
    }
    this.setState({
        YEARS: temp
    });

    window.addEventListener("keydown", this.checkEnterPress);

    this.props.getLevels()
    this.props.getSubjects()
    var currentProgress = localStorage.getItem("currentProgress");
    if(currentProgress){
      this.setState({currentProgress: Number(currentProgress)});
      const user = JSON.parse(localStorage.getItem("user"));
      this.setState({
        email:user.email,
        password: user.password
      })
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.get_school_loading && !this.props.get_school_loading) {
      if(this.props.get_school_success){
        let schools = []
        Object.keys(this.props.schools).map((keyName, i) => {
          schools[i] = {
            id: keyName, 
            name: this.props.schools[keyName]
          };            
        })
        this.setState({schools})          
      }
    };
    if (prevProps.get_levels_loading && !this.props.get_levels_loading) {
      if(this.props.get_levels_success){
        this.getLevelSubjects()
      }
    }
    if (prevProps.get_subjects_loading && !this.props.get_subjects_loading) {
      if(this.props.get_subjects_success){
        this.getLevelSubjects()
      }
    }

    if (prevProps.tutor_signup_loading && !this.props.tutor_signup_loading) {
      Helper.hideSpinner()
      if(this.props.tutor_signup_success){        
        this.setState({currentProgress: 2});
        localStorage.setItem("currentProgress", 2);
        const {email, password} = this.state
        const user = {
          email,
          password
        }
        localStorage.setItem("user", JSON.stringify(user));
      } else {
        Helper.showToast('error', 3000, this.props.tutor_signup_error_msg)
      }
    }

    if (prevProps.profile_update_loading && !this.props.profile_update_loading) {
      Helper.hideSpinner()
      if(this.props.profile_update_success){
        this.setState({currentProgress: 4});
        localStorage.setItem("currentProgress", 4);
      } else {
        Helper.showToast('error', 3000, this.props.profile_update_error_msg)
      }
    }
  };

  getLevelSubjects = () => {
    if(!_.isEmpty(this.props.levels) && !_.isEmpty(this.props.subjects)){
      let levels_subjects = []

      const { levels, subjects } = this.props;
      Object.keys(levels).map((level_keyName, i) => {
        levels_subjects[i] = {
          level_id: level_keyName,
          level_name: levels[level_keyName],
          subject: [],
        }
        Object.keys(subjects[level_keyName]).map((subject_keyName, j) => {
          levels_subjects[i].subject[j] =
            {subject_id: subject_keyName, subject_name: subjects[level_keyName][subject_keyName], checked: false}
        })
      })
      this.setState({levels_subjects});      
    }
  }

  updateLevelSubject = (res, index) => {
    let { levels_subjects } = this.state;
    levels_subjects[index].subject = res;
  };

  componentWillUnmount() {
    window.removeEventListener("keydown", this.checkEnterPress);
  }

  checkEnterPress = (e) => {
    if (e.keyCode !== 13) return;
  };  

  inputProgress_1 = (property, value, property2, value2,) => {
    this.setState({ 
        [property]: value,
        [property2]: value2,
    });
  };  

  scrollToDom = (section, part) => {
    const heightFromTop =
      (window.outerHeight -
        this.refs[`section${section}${part}`].offsetHeight) /
      2;
    const yToReach =
      this.refs[`section${section}${part}`].offsetTop - heightFromTop;
    this.workContainer.current.scrollTo({
      left: 0,
      top: yToReach,
      behavior: "smooth",
    });
  };  

  pickFileForPhoto = (e) => {
    e.preventDefault();
    if (!e.target.files[0]) return;
    this.setState({
      progress_4: {
        ...this.state.progress_4,
        photo: URL.createObjectURL(e.target.files[0]),
      },
    });
  };  

  scheduleConfirm = (status) => {
    this.setState({schedule_confirm: true});
  };   

  pickFileForPhoto = (e) => {
    e.preventDefault();
    if (!e.target.files[0]) return;
    this.setState({photo: URL.createObjectURL(e.target.files[0])});
    this.setState({upload_picture: e.target.files[0]});
  }

  getCityList = (cityName) => {
    if(cityName.length%2 === 0){
      this.props.getCities(cityName);
    };
  };

  getSchoolList = (schoolName) => {
    if(schoolName.length%2 === 0){
      const formData = new FormData();
      formData.append("data[school_name]", schoolName);
      this.props.getSchools(formData)      
    };
  };

  updateTrainingStatus = (training_status) => {   
    this.setState({training_status})
  };

  availabilityStatus = (schedule_data) => {
    this.setState({schedule_data});
  };

  next = () => {
    switch(this.state.currentProgress) {
      case 1:
        if(this.state.policy_checked){
          this.goToVideo();
        }
        return;
      case 2:
        this.goToAvailability();
        return;
      case 3:
        this.goToWelcome();
        return;      
      default:
        return 'next step';
    }
  }

  back = () => {
    switch(this.state.currentProgress) {
      case 1:
        this.goBack();
        return;
      case 2:
        // this.setState({currentProgress: 1})
        return;
      case 3:
        this.setState({currentProgress: 2})
        return;
      default:
        return 'back step';
    }
  }

  goToVideo = () => {
    this.setState({parms_validation: true});
    
    const {
      upload_picture, first_name, last_name, email, password, zipcode, city, region_id, phone,
      school1_id, major, major_gpa, 
      school2_id, degree2, degree2_type,
      school3_id, degree3, degree3_type,
      profile_title, fan_facts, about_me, experience, approach,
      levels_subjects,
      policy_checked,
      authorize_work,
      selected_month, day, year
    } = this.state;

    var classifications = [];
    levels_subjects.map((level, level_index)=> {
      level.subject.map((data, subject_index)=> {
        if(data.checked){
          classifications.push(`${level.level_id}-${data.subject_id}`)
        }
      })
    })
    this.setState({classifications: classifications.toString()})

    if( 
      upload_picture && first_name && last_name && email && password.length >= 8 && zipcode && region_id && phone && 
      school1_id && major && major_gpa && 
      profile_title && fan_facts && about_me && experience && approach &&
      !_.isEmpty(classifications) &&
      policy_checked
    ){
      this.tutorSignUp();
    } else {
      Helper.showToast('error', 3000, "Please fill all fields correctly!");
    }
  };

  goToAvailability = () => {
    if(this.state.training_status === 14){
      this.setState({currentProgress: 3});
      localStorage.setItem("currentProgress", 3);
    }
  };

  goToWelcome = () => {
    if(!_.isEmpty(this.state.schedule_data)) {
      this.updateSchedule();
    }
  }  

  tutorSignUp = () => {
    const {
      upload_picture, first_name, last_name, email, password, address, zipcode, city, region_id, phone,
      school1_id, major, major_gpa, 
      school2_id, degree2, degree2_type,
      school3_id, degree3, degree3_type,
      profile_title, fan_facts, about_me, experience, approach,
      classifications, schedule_data,
      authorize_work,
      selected_month, day, year
    } = this.state;   

    const signup_data = {
      upload_picture, first_name, last_name, email, password, address, zipcode, city, region_id, phone,
      school1_id, major, major_gpa, 
      school2_id, degree2, degree2_type,
      school3_id, degree3, degree3_type,
      profile_title, fan_facts, about_me, experience, approach,
      classifications,
      authorize_work,
      selected_month, day, year
    }
    
    Helper.showSpinner();
    const formData = new FormData()
    
    formData.append('data[username]', email);
    formData.append('data[password]', password);
    formData.append('data[first_name]', first_name);
    formData.append('data[last_name]', last_name);
    formData.append('data[region_id]', region_id);
    formData.append('data[phone]', phone);
    formData.append('data[address_street]', address);
    formData.append('data[address_zipcode]', zipcode);
    formData.append('data[profile_title]', profile_title);
    formData.append('data[classifications]', classifications);
    formData.append('data[school1_id]', school1_id);
    formData.append('data[major]', major);
    formData.append('data[major_gpa]', major_gpa);
    formData.append('data[school2_id]', school2_id);
    formData.append('data[degree2]', degree2);
    formData.append('data[degree2_type]', degree2_type);
    formData.append('data[school3_id]', school3_id);
    formData.append('data[degree3]', degree3);
    formData.append('data[degree3_type]', degree3_type);
    formData.append('data[fun_facts]', fan_facts);
    formData.append('data[about_me]', about_me);
    formData.append('data[experience]', experience);
    formData.append('data[approach]', approach);
    formData.append('data[gender]', 'Male');
    formData.append('data[accept_term]', 1);
    formData.append('data[picture]', upload_picture);
    formData.append('data[authorize_work]', authorize_work? 1 : 0);
    formData.append('data[date_of_birth]', `${year}-${selected_month}-${day}`);
    
    this.props.tutorSignUp(formData);
  };
  
  updateSchedule = () => {
    Helper.showSpinner();

    const {
      email, password, schedule_data
    } = this.state;

    var schedule = ''

    Hours.map((hour, hour_index)=> {
      WeekData.map((date, date_index)=> {
       _.find(schedule_data, {day: date, hour: hour}) ?
        schedule=  schedule.concat('0')
       :
        schedule= schedule.concat('1')
      })
    })

    const formData = new FormData()
    formData.append('data[username]', email);
    formData.append('data[password]', password);
    formData.append('data[schedule]', schedule);
    this.props.tutorProfileUpdate(formData);
  }
  
  goToDashboard = (url) => {
    if(url === 'practice'){
      this.setState({practice: true});
      window.open("https://frogtutoring.com/frogtutoring/lessonspacedemo");
    } else {
      if(this.state.practice){
        window.location.href = GetDashboardUrl(url)
      }
    }
  };

  goBack = () => {
    window.location.href = GetDashboardUrl("back")
  };

  signin = () => {
    window.location.href = "https://frogtutoring.com/users/login?redirect=no"
  };

  policyReadMore = () => {
    window.open("https://frogtutoring.com/files/tos/FrogTutoring_tutor_contract.pdf");
  }

  render() {
    const {
      schools, levels_subjects,
      photo, upload_picture, currentProgress, first_name, last_name, email, password, address, city, region_id, zipcode, phone, referal_code,
      school1_id, school1_name, major, major_gpa,
      school2_id, school2_name, degree2, degree2_type,
      school3_id, school3_name, degree3, degree3_type,     
      profile_title, fan_facts, about_me, experience, approach, 
      parms_validation, training_status, classifications,
      schedule_data,
      policy_checked,
      practice,
      selected_month, month, day, year, YEARS,
      authorize_work
    } = this.state;
    const { signErr, cities } = this.props;   
    return (
      <div className="tutorsignup-page">
        <div className="progress-explain">
          <ReactSVG
            src={arrow}
            style={{
              fill: "white",
              cursor: "pointer",
              top: "32px",
              left: "31px",
              position: "absolute",
            }}
            onClick={(e) => this.goBack()}
          />
          {/* <div className="bg-dot custom-bg" /> */}
          <div className="explain-content">
            {currentProgress === 1 && (
              <div id="section-explain-1">            
                <div className="logo-icon" onClick={()=> this.goBack()}>
                  <img src={logo}  alt="logo" />
                </div>
                <h1>Become a Tutor</h1>
                <div className="become-tutor-explain">
                  <p>•</p>
                  <p>Compensation is $20-$25 per hour</p>
                </div>
                <div className="become-tutor-explain">
                  <p>•</p>
                  <p>Make your work schedule</p>
                </div>
                <div className="become-tutor-explain">
                  <p>•</p>
                  <p>Get paid daily</p>
                </div>
                <div className="become-tutor-explain">
                  <p>•</p>
                  <p>Get compensated for driving over a certain mileage</p>
                </div>
                <div className="become-tutor-explain">
                  <p>•</p>
                  <p>Tutor both online and in-person</p>
                </div>
                <div className="become-tutor-explain">
                  <p>•</p>
                  <p>Get periodic bonuses based on performance</p>
                </div>
                <div className="become-tutor-explain">
                  <p>•</p>
                  <p>Tutor of the month recognition</p>
                </div>
                <div className="become-tutor-explain">
                  <p>•</p>
                  <p>Generous referral bonuses</p>
                </div>
                <div className="become-tutor-explain">
                  <p>•</p>
                  <p>Be an academic coach and a mentor to local students</p>
                </div>
                <div className="become-tutor-explain">
                  <p>•</p>
                  <p>You pick the age range and subjects to teach</p>
                </div>
              </div>
            )}
            {currentProgress === 2 && (
              <div id="section-explain-2">
                <h2>Complete training video</h2>
              </div>
            )}
            {currentProgress === 3 && (
              <div id="section-explain-3">
                <h2>Set Availability</h2>
              </div>
            )}
            {currentProgress === 4 && (
              <div id="section-explain-3">
                <h2>Practice using online tutoring platform</h2>
              </div>
            )}
          </div>
        </div>
        <div className="work-area" ref={this.workContainer}>
          <div className="container work-container">
            {currentProgress === 1 && (
              <div className="work-content" id="section-1">
                <div className="row show-mobile-flex" id="section-1-title">
                  <div className="col-lg-12">
                    <div className="show-mobile header">
                      <div onClick={()=> this.goBack()}>
                        <img src={logo_mobile} className="logo-icon" alt="logo" />
                      </div>
                      <div className="sign-btn shadow-object v-c h-c" onClick={()=>this.signin()}>Sign In</div>
                    </div>
                    <h2 className="text-center">Become a tutor</h2>
                    <div className="become-tutor-summary mt-3 mb-3">
                      <div className="become-tutor-explain">
                        <p>•</p>
                        <p>Compensation starts from $20-$25 per hour</p>
                      </div>
                      <div className="become-tutor-explain">
                        <p>•</p>
                        <p>Make your work schedule</p>
                      </div>
                      <div className="become-tutor-explain">
                        <p>•</p>
                        <p>Get paid daily</p>
                      </div>
                      <div className="become-tutor-explain">
                        <p>•</p>
                        <p>Get compensated for driving over a certain mileage</p>
                      </div>
                      <div className="become-tutor-explain">
                        <p>•</p>
                        <p>Tutor both online and in-person</p>
                      </div>
                      <div className="become-tutor-explain">
                        <p>•</p>
                        <p>Get periodic bonuses based on performance</p>
                      </div>
                      <div className="become-tutor-explain">
                        <p>•</p>
                        <p>Tutor of the month recognition</p>
                      </div>
                      <div className="become-tutor-explain">
                        <p>•</p>
                        <p>Generous referral bonuses</p>
                      </div>
                      <div className="become-tutor-explain">
                        <p>•</p>
                        <p>Be an academic coach and a mentor to local students</p>
                      </div>
                      <div className="become-tutor-explain">
                        <p>•</p>
                        <p>You pick the age range and subjects to teach</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row section-1-row" id="section-1-1">
                  <div className="sign-btn-container show-web">
                    <div className="sign-btn shadow-object v-c h-c" onClick={()=>this.signin()}>Sign In</div>
                  </div>
                  <div className="col-lg-12">
                    <h1>Personal Info</h1>
                  </div>

                  <div className="col-lg-12">
                    <div className="photo-area v-c my-2">
                      <div className="initial-name h-c v-c">
                        {photo && <img src={photo} style={{width:'100%',height:'100%', borderRadius:'50%'}} alt="avatar" /> }
                        <input type="file" accept="image/*" id="image_picker" style={{display:'none'}} onChange={e => this.pickFileForPhoto(e)}></input>
                      </div >
                      <div className="l-c mt-4">
                        <label htmlFor="image_picker"><div className={`upload_picture btn-2 btn-2-outline upload_btn v-c h-c ${parms_validation && !upload_picture ? "upload-picture-error" : ""}`}>Upload Photo</div></label>
                        <div className="ml-2">(Linkedin-like profile pic)</div>
                      </div>
                    </div>
                  </div>                  

                  <div className="col-lg-6 profile-col">
                    {" "}
                    <InputBox
                      icon={user}
                      placeholder="First Name"
                      value={first_name}
                      onChange={(e) => this.inputProgress_1("first_name", e)}
                      className={`input-box ${parms_validation && !first_name ? "inputbox-container-error" : ""}`}
                    />{" "}
                  </div>
                  <div className="col-lg-6 profile-col">
                  {" "}
                    <InputBox                      
                      placeholder="Last Name"
                      value={last_name}
                      onChange={(e) => this.inputProgress_1("last_name", e)}
                      className={`input-box ${parms_validation && !last_name ? "inputbox-container-error" : ""}`}
                    />{" "}
                  </div>

                  <div className="col-lg-12">
                    <p className="option-title">Birthdate</p>
                  </div>
                  <div className="col-lg-4 profile-col">
                    <SelectBox2 className="option-select" value={month} options={Months} onChange={val => this.setState({month: val.name, selected_month: val.id})}/>
                  </div>
                  <div className="col-lg-4 profile-col">
                    <SelectBox2 className="option-select" value={day} options={Days} onChange={val => this.setState({day: val.name})}/>
                  </div>
                  <div className="col-lg-4 profile-col">
                    {YEARS.length > 0 && <SelectBox2 className="option-select" value={year} options={YEARS} onChange={val => this.setState({year: val.name})}/>}
                  </div>

                  <div className="col-lg-6 profile-col">
                    {" "}
                    <InputBox
                      icon={email_ico}
                      placeholder="E-mail"
                      value={email}
                      onChange={(e) => this.inputProgress_1("email", e)}
                      className={`input-box ${parms_validation && !email ? "inputbox-container-error" : ""}`}
                    />{" "}
                  </div>
                  <div className="col-lg-6 profile-col">
                    {" "}
                    <InputBox
                      icon={key}
                      placeholder="Create Password"
                      value={password}
                      onChange={(e) => this.inputProgress_1("password", e)}
                      type={'password'}
                      className={`input-box ${parms_validation && password.length < 8? "inputbox-container-error" : ""}`}
                    />{" "}
                    <div className="subject-error-txt">{parms_validation && password.length < 8? "password must be over 8" : ""}</div>
                  </div>
                  <div className="col-lg-12 profile-col">
                    {" "}
                    <InputBox
                      placeholder="Address"
                      value={address}
                      onChange={(e) => this.inputProgress_1("address", e)}
                      className="input-box"
                    />{" "}
                  </div>
                  <div className="col-lg-6 profile-col">
                    {" "}
                    <InputBox
                      icon={place}
                      placeholder="Zipcode"
                      value={zipcode}
                      onChange={(e) => this.inputProgress_1("zipcode", e)}
                      className={`input-box ${parms_validation && !zipcode ? "inputbox-container-error" : ""}`}
                    />{" "}
                  </div>
                  <div className="col-lg-6 profile-col">
                    {" "}
                    <SelectBox
                      placeholder="City"
                      show_arrow
                      options={cities || []}
                      value={city}
                      isCity={true}
                      onChange={(e) =>
                        this.inputProgress_1("region_id", e.id, "city", e.name)
                      }
                      className={`input-box ${parms_validation && !region_id ? "selectbox-container-error" : ""}`}
                      changeTxt={(e)=>this.getCityList(e)}
                    />
                    {" "}
                  </div>
                  
                  <div className="col-lg-12 profile-col">
                    {" "}
                    <InputBox
                      placeholder="Have a referal code (optional)"
                      value={referal_code}
                      onChange={(e) => this.inputProgress_1("referal_code", e)}
                      className="input-box"
                    />{" "}
                  </div>
                  <div className="col-lg-12 profile-col">
                    <InputBox 
                      className={`input-box ${parms_validation && !phone ? "inputbox-container-error" : ""}`}
                      phone_input 
                      type="number" 
                      placeholder={"Phone number"} 
                      value={this.state.phone} 
                      country={this.state.country} 
                      onSelect={e => this.inputProgress_1("country", e)} 
                      onChange={e => this.inputProgress_1("phone", e)}/>         
                  </div>

                  <div className="col-lg-12 profile-col" style={{display: 'flex'}}>
                    <div className="mr-2">
                      <CheckBox
                        className="check-box"
                        value={authorize_work}
                        onChange={(e) => this.setState({ authorize_work: e })}
                      />
                    </div>
                    <div className="policy-txt">
                      Are you authorized to work in the US?
                    </div>
                  </div>    
                </div>            


                {/* ---------------------- levels and subjects ------------------ */}
                <div>
                  <div className="row section-1-row" id="section-1-2" ref="section12">
                    <div className="col-lg-12">
                      <h1>
                        Select the subjects you are interested in tutoring for each classification.
                      </h1>
                      <div className="subject-error-txt">{parms_validation && !classifications? "Need 1 interested subject at least!" : ""}</div>
                    </div>
                    <div className="col-lg-12">
                      {levels_subjects && levels_subjects.map((data, index) => (
                        <CheckSection
                          key={index}
                          className="check-section" 
                          title={data.level_name} 
                          data={data.subject}
                          onChange={res => this.updateLevelSubject(res, index)}
                        />
                      ))}
                    </div>
                  </div>
                </div>

                {/* ------------------------ Education Part------------------------ */}
                <div className="row section-1-row" id="section-1-6" ref="section116">
                  <div className="col-lg-12">
                    <h1>Education</h1>
                  </div>
                  {/* ------------shcool1---------------   */}
                  <div className="col-lg-12 profile-col">
                    {" "}
                    <SelectBox
                      // icon={shoppingList}
                      placeholder="Undergraduate School"
                      show_arrow
                      options={schools || []}
                      value={school1_name}
                      onChange={(e) =>
                        this.inputProgress_1("school1_id", e.id, "school1_name", e.name)
                      }
                      className={`input-box ${parms_validation && !school1_id ? "selectbox-container-error" : ""}`}
                      changeTxt={(e)=>this.getSchoolList(e)}
                    />{" "}
                  </div>
                  <div className="col-lg-12 profile-col">
                    {" "}
                    <InputBox
                      placeholder="Major"
                      value={major}
                      onChange={(e) => this.inputProgress_1("major", e)}
                      className={`input-box ${parms_validation && !major ? "inputbox-container-error" : ""}`}
                    />{" "}
                  </div>
                  <div className="col-lg-12 profile-col third-col">
                    {" "}
                    <InputBox
                      placeholder="What is your major GPA?"
                      value={major_gpa}
                      onChange={(e) => this.inputProgress_1("major_gpa", e)}
                      className={`input-box ${parms_validation && !major_gpa ? "inputbox-container-error" : ""}`}


                    />{" "}
                  </div>
                  {/* ------------shcool2---------------   */}
                  <div className="col-lg-12 profile-col">
                    {" "}
                    <SelectBox
                      placeholder="Graduate School (optional)"
                      show_arrow
                      options={schools}
                      value={school2_name}
                      onChange={(e) =>
                        this.inputProgress_1("school2_id", e.id, "school2_name", e.name)
                      }
                      className="input-box"
                      changeTxt={(e)=>this.getSchoolList(e)}
                    />{" "}
                  </div>
                  <div className="col-lg-12 profile-col">
                    {" "}
                    <InputBox
                      placeholder="Degree"
                      value={degree2}
                      onChange={(e) => this.inputProgress_1("degree2", e)}
                      className="input-box"
                    />{" "}
                  </div>
                  <div className="col-lg-12 profile-col third-col">
                    <SelectBox
                      placeholder="Please select a type"
                      show_arrow
                      options={DegreeType}
                      value={degree2_type}
                      onChange={(e) => this.inputProgress_1("degree2_type", e.name)}
                      className="input-box"
                      changeTxt={(e)=>console.log('typing', e)}
                    />
                  </div>
                  {/* ------------shcool3---------------   */}
                  <div className="col-lg-12 profile-col">
                    {" "}
                    <SelectBox
                      placeholder="Graduate School (optional)"
                      show_arrow
                      options={schools}
                      value={school3_name}
                      onChange={(e) =>
                        this.inputProgress_1("school3_id", e.id, "school3_name", e.name)
                      }
                      className="input-box"
                      changeTxt={(e)=>this.getSchoolList(e)}
                    />{" "}
                  </div>
                  <div className="col-lg-12 profile-col">
                    {" "}
                    <InputBox
                      placeholder="Degree"
                      value={degree3}
                      onChange={(e) => this.inputProgress_1("degree3", e)}
                      className="input-box"
                    />{" "}
                  </div>
                  <div className="col-lg-12 profile-col">
                    <SelectBox
                      placeholder="Please select a type"
                      show_arrow
                      options={DegreeType}
                      value={degree3_type}
                      onChange={(e) => this.inputProgress_1("degree3_type", e.name)}
                      className="input-box"
                      changeTxt={(e)=>console.log('typing', e)}
                    />
                  </div>
                </div>
                
                {/* ------------------------ profile Part------------------------ */}
                
                <div className="row section-1-row" id="section-1-6" ref="section116">
                  <div className="col-lg-12">
                    <h1>Profile Title</h1>
                  </div>
                  <div className="col-lg-12">
                    <textarea
                      placeholder="Experienced Math & Science Ivy League Tutor"
                      value={profile_title}
                      maxLength="45"
                      onChange={(e) =>
                        this.inputProgress_1("profile_title", e.target.value)
                      }
                      className={parms_validation && !profile_title ? "textarea-error" : ""}
                    />                    
                  </div>
                </div>
                <div className="row section-1-row" id="section-1-6" ref="section116">
                  <div className="col-lg-12">
                    <h1>Fun Facts</h1>
                  </div>
                  <div className="col-lg-12">
                    <textarea
                      placeholder="One passion people quickly learn about me is that I LOVE golf! Any time I have a chance, you will find me playing or studying the sport. I am the oldest of seven, and have never been out of Texas."
                      value={fan_facts}
                      // maxLength="50"
                      onChange={(e) =>
                        this.inputProgress_1("fan_facts", e.target.value)
                      }
                      className={parms_validation && !fan_facts ? "textarea-error" : ""}
                    />
                  </div>
                </div>
                <div className="row section-1-row" id="section-1-6" ref="section116">
                  <div className="col-lg-12">
                    <h1>About Me</h1>
                  </div>
                  <div className="col-lg-12">
                    <textarea
                      placeholder="I am a senior Accounting major at Texas Christian University. I've been on the Dean's List for 2 years in a row! When I graduate, I hope to attend the University of Texas is Arlington to earn my Masters."
                      value={about_me}
                      onChange={(e) =>
                        this.inputProgress_1("about_me", e.target.value)
                      }
                      className={parms_validation && !about_me ? "textarea-error" : ""}
                    />
                    <div className="under-dot additional-bg" />
                  </div>
                </div>
                <div className="row section-1-row" id="section-1-6" ref="section116">
                  <div className="col-lg-12">
                    <h1>Experience</h1>
                  </div>
                  <div className="col-lg-12">
                    <textarea
                      placeholder="As a member of National Junior Honor Society, I had the opportunity to tutor students bi-weekly in all subject areas during my senior year in high school."
                      value={experience}
                      onChange={(e) =>
                        this.inputProgress_1("experience", e.target.value)
                      }
                      className={parms_validation && !experience ? "textarea-error" : ""}
                    />
                  </div>
                </div>
                <div className="row section-1-row" id="section-1-6" ref="section116">
                  <div className="col-lg-12">
                    <h1>Approach</h1>
                  </div>
                  <div className="col-lg-12">
                    <textarea
                      placeholder="As a child, I struggled in school and found learning to be difficult and demoralizing. In middle school, I was fortunate enough to have a teacher who, through positive encouragement and persistence."
                      value={approach}
                      onChange={(e) =>
                        this.inputProgress_1("approach", e.target.value)
                      }
                      className={parms_validation && !approach ? "textarea-error" : ""}
                    />
                  </div>
                </div>
                
                <div className="policy-area">
                  <div className="mr-2">
                    <CheckBox
                      className="check-box"
                      value={policy_checked}
                      onChange={(e) => this.setState({ policy_checked: e })}
                    />
                  </div>
                  <div className="policy-txt">
                    I agree to Frogtutorings’ terms of service and privacy policy for tutors 
                    <strong className="ml-2 read-more" onClick={()=>this.policyReadMore()}>Read More</strong>{" "}
                  </div>
                </div>
              </div>
            )}
            {currentProgress === 2 && (
              <div className="work-content v-r" id="section-2">
                {/* <div className="row show-mobile-flex" id="section-2-title">
                  <div className="col-lg-12">
                    <h2>Become a tutor</h2>
                  </div>  
                </div> */}

                <TrainingVideo 
                  training_status={training_status} 
                  updateTrainingStatus={(e) => this.updateTrainingStatus(e)}
                />
              </div>
            )}
            {currentProgress === 3 && (
              <div className="work-content v-r" id="section-3">         
                
                <Availability
                  schedule_data={schedule_data}
                  availabilityStatus={(e) => this.availabilityStatus(e)}                  
                />
              </div>
            )}
            {currentProgress === 4 && (
              <div className="work-content v-r" id="section-4">
                
                <div className="welcome">
                  <div className="welcome-text">
                    1. Congratulations! You have completed the onboarding process. <br />
                    2. A member of our hiring team will be in touch with you to explain the next step in the process and to verify your account. <br />
                    3. <strong className="demo-highlight" onClick={()=>this.goToDashboard("practice")}>Click here to practice using our online tutoring platform.</strong> We strongly recommend you play around with it to get familiar with the interphase. <br />
                    4. Click the " Go To My Portal" below to access your tutoring portal
                  </div>
                </div>

                <div className="start-button-container">                                    
                    <StartButton
                      className="start-btn show-web-flex"
                      height="65px"
                      startText= "Go To My Portal"
                      onClick={()=>this.goToDashboard("demo")}
                      isReady={practice}
                    />
                    <StartButton
                    className="start-btn show-mobile-flex"
                    height="50px"
                    startText= "Go To My Portal"
                    onClick={(e) => this.goToDashboard("demo")}
                    isReady={practice}
                  />
                </div>
              </div>
            )}
          </div>

          {/* ------------------------ submit Part------------------------ */}          
          {currentProgress !== 4 && <div className={`submit-area`}>
            <div className="container submit-container" style={{ paddingBottom: 100 }}>
              <div className="btn-area" ref="section00">
                {/* <div className="back-btn" onClick={(e) => this.back()}>
                  <div className="back-icon center-item">
                    <ReactSVG src={arrow} style={{ fill: "#C0C5C9" }} />
                  </div>
                  <div className="back-text center-item">Back</div>
                </div> */}
                
                <div>
                  <StartButton
                    className="start-btn show-web-flex"
                    height="65px"
                    startText={currentProgress === 2? "Set Availability": "Continue"}
                    onClick={(e) => this.next()}
                    isReady={
                      currentProgress ===1 ? policy_checked :
                      currentProgress ===2 && training_status ===14? true :
                      currentProgress ===3 && !_.isEmpty(schedule_data)? true : false
                    }
                  />
                  <StartButton
                    className="start-btn show-mobile-flex"
                    height="50px"
                    startText={currentProgress === 2? "Set Availability": "Continue"}
                    onClick={(e) => this.next()}
                    isReady={
                      currentProgress ===1 ? true :
                      currentProgress ===2 && training_status ===14? true :
                      currentProgress ===3 && !_.isEmpty(schedule_data)? true : false
                    }
                  />
                </div>
              </div>
            </div>
          </div>}
        </div>       
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  schools: state.School.schools,
  get_school_loading: state.School.get_school_loading,
  get_school_success: state.School.get_school_success,
  cities: state.City.cities,
  levels: state.Level.levels,
  get_levels_loading: state.Level.get_levels_loading,
  get_levels_success: state.Level.get_levels_success,
  subjects: state.Subject.subjects,
  get_subjects_loading: state.Subject.get_subjects_loading,
  get_subjects_success: state.Subject.get_subjects_success,


  tutor_signup_loading: state.Auth.tutor_signup_loading,
  tutor_signup_success: state.Auth.tutor_signup_success,
  tutor_signup_error_msg: state.Auth.tutor_signup_error_msg,

  profile_update_loading: state.Auth.profile_update_loading,
  profile_update_success: state.Auth.profile_update_success,
  profile_update_error_msg: state.Auth.profile_update_error_msg,

  user: state.Auth.user,
  token: state.Auth.token,  
});

export default connect(mapStateToProps, {
  tutorSignUp,
  tutorProfileUpdate,
  getSchools,
  getCities,
  getLevels,
  getSubjects
})(withRouter(TutorSignUpPage));


